export const ECHARTS_COLORS = [
  '#8980FF',
  '#752FEC',
  '#6D2CBF',
  '#43128E',
  '#4225B0',
  '#3F47CB',
  '#3C69E6',
  '#3A7AF3',
  '#1A9CE4',
  '#05B3DA',
  '#009FBF',
  '#04BACD',
  '#11BBAD',
  '#57F780',
  '#93F4A6'
];

export const PROGRESSBAR_CHART_COLORS = [
  "#43128E", "#752FEC", "#8980FF", "#3F47CB", "#3C69E6",
  "#3A7AF3", "#1A9CE4", "#05B3DA", "#009FBF", "#04BACD"
];